import { SolarFormModel } from '../quote-or-design-form/solar/solarFormModel';
import { FixingKitTypeCode } from './fixingKitTypeCode';

export type SolarResponse = {
  fixingKitTypeCode: FixingKitTypeCode;
  assumedDomesticHotWaterDemandInLitresPerDay: number | null;
  solarPanelQuantity: number | null;
  solarInputInKilowattHoursPerYear: number | null;
  solarFractionPercentage: number | null;
  includingHotWaterCylinder: boolean;
};

export const mapSolarResponseToFormModel = (response: SolarResponse): SolarFormModel => ({
  isExpanded: true,
  fixingKitTypeCode: response.fixingKitTypeCode,
  assumedDomesticHotWaterDemandInLitresPerDay: response.assumedDomesticHotWaterDemandInLitresPerDay?.toString() ?? '',
  solarPanelQuantity: response.solarPanelQuantity,
  solarInputInKilowattHoursPerYear: response.solarInputInKilowattHoursPerYear?.toString() ?? '',
  solarFractionPercentage: response.solarFractionPercentage?.toString() ?? '',
  includingHotWaterCylinder: response.includingHotWaterCylinder,
});
